/* @flow */
import Entity from 'lib/Entity';
import Avatar from 'entities/Avatar';

class MessageRecipient extends Entity {
  parse(response: Object): Object {
    if (response['group_avatar']) {
      response['group_avatar'] = Avatar.fromJSON(response['group_avatar']);
    }

    return response;
  }

  defaults() {
    return {
      deleted: false,
    };
  }

  getName(): string {
    return this.get('name');
  }

  getGroupAvatar(): string {
    return this.get('group_avatar');
  }

  getType(): string {
    return this.get('type');
  }

  isDeleted(): boolean {
    return this.get('deleted');
  }

  isGroup(): boolean {
    return this.getType() === 'group';
  }

  isSubscriber(): boolean {
    return this.getType() === 'subscriber';
  }
}

export default MessageRecipient;



// WEBPACK FOOTER //
// ./src/entities/MessageRecipient.js